"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATE_PICKER_CHANGE_REASON = void 0;
var DATE_PICKER_CHANGE_REASON = Object.freeze({
  MANUAL_INPUT: 'manual input',
  DROPDOWN_CLICK: 'dropdown click',
  DROPDOWN_KEYBOARD: 'dropdown keyboard'
});
exports.DATE_PICKER_CHANGE_REASON = DATE_PICKER_CHANGE_REASON;